document.querySelectorAll(".custom-select__option").forEach((el) => {
  const swatchColor = el.getAttribute("data-swatch");
  el.style.setProperty("--swatch-color", swatchColor);
});

document.querySelectorAll('.custom-select__listbox').forEach(li=>{
    li.addEventListener('click', function(){
      let color = event.target.dataset.color;

      setTimeout(()=>{

        document.querySelectorAll(".custom-select__btn").forEach(ele=>{
          const swatchColor = ele.getAttribute("data-swatch");
          ele.style.setProperty("--swatch-color", swatchColor);
        })


        
      }, 150);
      
      
      
    })
})

window.jdgmReviewLimiter = {
  wordLimit: 40,
  selector: '.jdgm-carousel-wrapper .jdgm-carousel-item__review-body p'
};

(function (settings) {
  if (!settings) return;

  
  function normalizeText(text) {
    return (text || '').trim().replace(/\s+/g, ' ');
  }

  function getLimitedText(text, limit) {
    const cleanText = normalizeText(text);
    if (!cleanText) return '';

    const words = cleanText.split(' ');
    if (words.length <= limit) return cleanText;

    return words.slice(0, limit).join(' ') + '...';
  }

  function limitJudgeMeReviews() {
    const items = document.querySelectorAll(settings.selector);
   
    if (!items.length) return;

    items.forEach(function (item) {
      const liveText = normalizeText(item.textContent);

      if (!item.dataset.fullReview) {
        item.dataset.fullReview = liveText;
      }

      const finalText = getLimitedText(item.dataset.fullReview, settings.wordLimit);

      if (normalizeText(item.textContent) !== finalText) {
        item.textContent = finalText;
      }
    });
  }

  function initJudgeMeLimiter() {
    limitJudgeMeReviews();

    const observer = new MutationObserver(function () {
      limitJudgeMeReviews();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    let tries = 0;
    const timer = setInterval(function () {
      limitJudgeMeReviews();
      tries++;

      if (tries > 80) {
        clearInterval(timer);
      }
    }, 700);

    window.addEventListener('load', limitJudgeMeReviews);
    document.addEventListener('DOMContentLoaded', limitJudgeMeReviews);
  }

  initJudgeMeLimiter();
})(window.jdgmReviewLimiter);
